/**
 * App — the react-router route table over the locked AppShell layout. The AppShell parent route owns
 * the header + global DataHealthBanner + SkyNavDrawer + <Outlet/>; every screen renders inside the
 * Outlet (its own PageHeader -> content -> PageFooter). Real pages: Roster (and Dashboard landing).
 * Honest DEFERRED/MOCK/PARTIAL stubs elsewhere; "*" falls to NotFound. The Phase-1 hand-rolled <nav>
 * shell is gone.
 */
import { Routes, Route } from "react-router-dom";
import { AppShell } from "./shell/AppShell";
import { Roster } from "./pages/Roster";
import { Dashboard } from "./pages/Dashboard";
import { Member360, MemberDefault } from "./pages/Member360";
import { Vitals } from "./pages/Vitals";
import { Encounters } from "./pages/Encounters";
import { Population } from "./pages/Population";
import { Census } from "./pages/Census";
import { CareGaps } from "./pages/CareGaps";
import { Quality } from "./pages/Quality";
import { Medications } from "./pages/Medications";
import { Idt } from "./pages/Idt";
import { Utilization } from "./pages/Utilization";
import { DataHealth } from "./pages/DataHealth";
import { Matrix } from "./pages/Matrix";
import { AdminUsers } from "./pages/admin/Users";
import { AdminRoles } from "./pages/admin/Roles";
import { AdminTenants } from "./pages/admin/Tenants";
import { AdminInstances } from "./pages/admin/Instances";
import { AdminAuditLog } from "./pages/admin/AuditLog";
import { NotFound } from "./pages/NotFound";

export function App() {
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route index element={<Dashboard />} />
        <Route path="roster" element={<Roster />} />
        <Route path="member" element={<MemberDefault />} />
        <Route path="member/:key" element={<Member360 />} />
        <Route path="vitals" element={<Vitals />} />
        <Route path="encounters" element={<Encounters />} />
        <Route path="population" element={<Population />} />
        <Route path="census" element={<Census />} />
        <Route path="care-gaps" element={<CareGaps />} />
        <Route path="quality" element={<Quality />} />
        <Route path="medications" element={<Medications />} />
        <Route path="idt" element={<Idt />} />
        <Route path="utilization" element={<Utilization />} />
        <Route path="data-health" element={<DataHealth />} />
        <Route path="data-health/matrix" element={<Matrix />} />
        <Route path="admin/users" element={<AdminUsers />} />
        <Route path="admin/roles" element={<AdminRoles />} />
        <Route path="admin/tenants" element={<AdminTenants />} />
        <Route path="admin/instances" element={<AdminInstances />} />
        <Route path="admin/audit-log" element={<AdminAuditLog />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
